export const CallScheduleIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="
    http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2571_10918)">
        <path
          d="M11.3392 20.6617L11.3483 20.6681C12.1404 21.1724 13.0808 21.3914 14.0141 21.2889C14.9475 21.1864 15.8179 20.7685 16.4817 20.1043L17.0583 19.5278C17.186 19.4001 17.2874 19.2485 17.3565 19.0816C17.4257 18.9147 17.4613 18.7358 17.4613 18.5552C17.4613 18.3745 17.4257 18.1957 17.3565 18.0288C17.2874 17.8619 17.186 17.7103 17.0583 17.5826L14.6263 15.1525C14.4986 15.0247 14.347 14.9234 14.1801 14.8542C14.0133 14.7851 13.8344 14.7495 13.6538 14.7495C13.4731 14.7495 13.2942 14.7851 13.1274 14.8542C12.9605 14.9234 12.8089 15.0247 12.6812 15.1525C12.4233 15.4103 12.0736 15.5551 11.709 15.5551C11.3444 15.5551 10.9948 15.4103 10.7369 15.1525L6.84842 11.2631C6.59064 11.0052 6.44584 10.6556 6.44584 10.291C6.44584 9.92637 6.59064 9.5767 6.84842 9.31885C6.97619 9.19116 7.07755 9.03954 7.14671 8.87266C7.21586 8.70578 7.25146 8.52691 7.25146 8.34626C7.25146 8.16562 7.21586 7.98675 7.14671 7.81987C7.07755 7.65299 6.97619 7.50137 6.84842 7.37368L4.41742 4.9436C4.15957 4.68582 3.80989 4.54102 3.44529 4.54102C3.08069 4.54102 2.73102 4.68582 2.47317 4.9436L1.89567 5.52018C1.23162 6.18401 0.813927 7.05452 0.711591 7.98788C0.609256 8.92123 0.828407 9.86157 1.33283 10.6535L1.33833 10.6627C4.00233 14.6042 7.39721 17.9984 11.3392 20.6617Z"
          stroke="#8b58f1"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.6875 5.5C11.6875 6.13199 11.812 6.75779 12.0538 7.34166C12.2957 7.92554 12.6502 8.45607 13.097 8.90295C13.5439 9.34983 14.0745 9.70432 14.6583 9.94617C15.2422 10.188 15.868 10.3125 16.5 10.3125C17.132 10.3125 17.7578 10.188 18.3417 9.94617C18.9255 9.70432 19.4561 9.34983 19.903 8.90295C20.3498 8.45607 20.7043 7.92554 20.9462 7.34166C21.188 6.75779 21.3125 6.13199 21.3125 5.5C21.3125 4.86801 21.188 4.24222 20.9462 3.65834C20.7043 3.07446 20.3498 2.54393 19.903 2.09705C19.4561 1.65017 18.9255 1.29568 18.3417 1.05383C17.7578 0.811979 17.132 0.6875 16.5 0.6875C15.868 0.6875 15.2422 0.811979 14.6583 1.05383C14.0745 1.29568 13.5439 1.65017 13.097 2.09705C12.6502 2.54393 12.2957 3.07446 12.0538 3.65834C11.812 4.24222 11.6875 4.86801 11.6875 5.5Z"
          stroke="#8b58f1"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5 3.4375V5.5H18.5625"
          stroke="#8b58f1"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2571_10918">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
